import React, { useCallback } from 'react';
import { Option, Select } from 'carbon-react/lib/components/select';

import { useIntl } from '@futrli/localisation';
import { ListingPageFilterBar } from '@futrli/ui-components/components/listing-page/listing-page-filter-bar/listing-page-filter-bar';

import { SortOption } from '../../../../utils/list-filters/list-filter-utils';

interface ExportedPdfsFiltersProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  sortValue: string;
  onSortChange: (value: string) => void;
  sortOptions: SortOption[];
  stickyTop?: number;
}

/**
 * Filter header for the Exported PDFs tab.
 * The simplest filter header — only Search + Sort by, no additional controls.
 */
export const ExportedPdfsFilters = ({
  searchTerm,
  onSearchChange,
  sortValue,
  onSortChange,
  sortOptions,
  stickyTop
}: ExportedPdfsFiltersProps) => {
  const intl = useIntl();

  const handleSortChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onSortChange(event.target.value);
    },
    [onSortChange]
  );

  return (
    <ListingPageFilterBar
      searchTerm={searchTerm}
      onSearchChange={onSearchChange}
      stickyTop={stickyTop}
      rightContent={
        <div style={{ minWidth: 250 }}>
          <Select
            id="exported-pdfs-sort-by"
            value={sortValue}
            onChange={handleSortChange}
            size="medium"
            label={intl.formatMessage({ id: 'predict.sort_by', defaultMessage: 'Sort by' })}
            aria-label={intl.formatMessage({ id: 'predict.sort_by', defaultMessage: 'Sort by' })}
          >
            {sortOptions.map(opt => (
              <Option key={opt.value} value={opt.value} text={opt.label} />
            ))}
          </Select>
        </div>
      }
    />
  );
};
